import { compare } from 'compare-versions'
import { native } from '../native'

export async function getStoreRegionSafe(
  appVersion: string,
): Promise<string | null> {
  if (!compare(appVersion, '5.7.0', '>=')) return null
  const result = await native.iap.getStoreRegion()
  if (!result.success) return null
  return result.data.region
}
